import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { SidebarModule } from "primeng-v17/sidebar";
import { SidebarAdditionalComponentDirective } from "../../shared/primeng/sidebar-additional-component/sidebar-additional-component.directive";
import { SidebarOptionsDirective } from "../../shared/primeng/sidebar-options/sidebar-options.directive";
import { NewUiUserFeedbackComponent } from "./new-ui-user-feedback.component";
import { UserFeedbackEditDialogComponent } from "./user-feedback-edit-dialog/user-feedback-edit-dialog.component";

@Component({
  selector: "app-user-feedback",
  templateUrl: "./user-feedback.component.html",
  imports: [
    SidebarModule,
    SidebarAdditionalComponentDirective,
    SidebarOptionsDirective,
    NgIf,
    UserFeedbackEditDialogComponent,
  ],
})
export class UserFeedbackComponent extends NewUiUserFeedbackComponent {}
